import { render, staticRenderFns } from "./embedProfile.vue?vue&type=template&id=404f7274&scoped=true&"
import script from "./embedProfile.vue?vue&type=script&lang=js&"
export * from "./embedProfile.vue?vue&type=script&lang=js&"
import style0 from "./embedProfile.vue?vue&type=style&index=0&id=404f7274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f7274",
  null
  
)

export default component.exports